import { useLayoutEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/** Owned by the persistent modal host, not the quote drawer that closes on success. */
export function useQuoteCompletionVisit(orderId: string | undefined) {
  const { pathname } = useLocation();
  const visit = useMemo(() => {
    let active = false;
    const timers = new Set<number>();
    return {
      activate: () => {
        active = true;
      },
      dispose: () => {
        active = false;
        timers.forEach((timer) => window.clearTimeout(timer));
        timers.clear();
      },
      isCurrent: () => active,
      schedule: (callback: () => void, delay: number) => {
        if (!active) return;
        const timer = window.setTimeout(() => {
          timers.delete(timer);
          if (active) callback();
        }, delay);
        timers.add(timer);
      }
    };
  }, [pathname, orderId]);

  useLayoutEffect(() => {
    visit.activate();
    return visit.dispose;
  }, [visit]);

  return visit;
}

export type QuoteCompletionVisit = Pick<
  ReturnType<typeof useQuoteCompletionVisit>,
  'isCurrent' | 'schedule'
>;
